module.exports = __webpack_public_path__ + "static/image502-a8945d29335c254105877f5b12c8b1b6.png";